import React from 'react';
import PropTypes from 'prop-types';

/**
 * @param {{ size: number; title: string; }} props
 */
export const MockVideoItem = ({ size, title }) => {
  const height = size * 2.85;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 0 267.735 101.74">
      {Boolean(title) && <title>{title}</title>}
      <defs>
        <filter
          id="Rectangle_1031"
          x="0"
          y="0"
          width="267.735"
          height="101.74"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_5899" data-name="Group 5899" transform="translate(-113 -276)">
        <g id="Group_5683" data-name="Group 5683" transform="translate(-971 -116.605)">
          <g id="Group_3362" data-name="Group 3362" transform="translate(1093 398.529)">
            <g transform="matrix(1, 0, 0, 1, -9, -5.92)" filter="url(#Rectangle_1031)">
              <rect
                id="Rectangle_1031-2"
                data-name="Rectangle 1031"
                width="249.735"
                height="83.74"
                rx="5"
                transform="translate(9 6)"
                fill="#fff"
              />
            </g>
            <rect
              id="Rectangle_1205"
              data-name="Rectangle 1205"
              width="59.687"
              height="40.271"
              transform="translate(43.899 21.462)"
              fill="#eaeaea"
            />
            <g id="Group_3041" data-name="Group 3041" transform="translate(212.027 40.077)">
              <path
                id="Path_55"
                data-name="Path 55"
                d="M3.292,1.646A1.472,1.472,0,0,1,1.646,3.292,1.472,1.472,0,0,1,0,1.646,1.472,1.472,0,0,1,1.646,0,1.472,1.472,0,0,1,3.292,1.646Z"
                transform="translate(0 3.292) rotate(-90)"
                fill="#959494"
              />
              <circle
                id="Ellipse_20"
                data-name="Ellipse 20"
                cx="1.646"
                cy="1.646"
                r="1.646"
                transform="translate(6.965 3.292) rotate(-90)"
                fill="#959494"
              />
              <path
                id="Path_56"
                data-name="Path 56"
                d="M3.292,1.646A1.472,1.472,0,0,1,1.646,3.292,1.472,1.472,0,0,1,0,1.646,1.472,1.472,0,0,1,1.646,0,1.472,1.472,0,0,1,3.292,1.646Z"
                transform="translate(13.929 3.292) rotate(-90)"
                fill="#959494"
              />
            </g>
            <g id="Group_3043" data-name="Group 3043" transform="translate(13.657 33.168)">
              <g id="Group_2778" data-name="Group 2778" transform="translate(0)">
                <g
                  id="Ellipse_171"
                  data-name="Ellipse 171"
                  fill="#6bb220"
                  stroke="#6bb220"
                  strokeWidth="1"
                >
                  <circle cx="8.5" cy="8.5" r="8.5" stroke="none" />
                  <circle cx="8.5" cy="8.5" r="8" fill="none" />
                </g>
                <path
                  id="Path_1294"
                  data-name="Path 1294"
                  d="M6.659.444A.711.711,0,0,0,5.993,0a.777.777,0,0,0-.666.37L2.292,5.033,1.4,3.923a.755.755,0,0,0-.592-.37A.814.814,0,0,0,.072,4a.563.563,0,0,0,.074.666l1.48,2.072a.883.883,0,0,0,.666.37.883.883,0,0,0,.666-.37l3.7-5.625A.555.555,0,0,0,6.659.444Z"
                  transform="translate(5.51 4.792)"
                  fill="#fff"
                />
              </g>
              <path
                id="Path_1294-2"
                data-name="Path 1294"
                d="M6.659.444A.711.711,0,0,0,5.993,0a.777.777,0,0,0-.666.37L2.292,5.033,1.4,3.923a.755.755,0,0,0-.592-.37A.814.814,0,0,0,.072,4a.563.563,0,0,0,.074.666l1.48,2.072a.883.883,0,0,0,.666.37.883.883,0,0,0,.666-.37l3.7-5.625A.555.555,0,0,0,6.659.444Z"
                transform="translate(5.51 4.792)"
                fill="#fff"
              />
            </g>
            <rect
              id="Rectangle_1284"
              data-name="Rectangle 1284"
              width="53.152"
              height="6.198"
              transform="translate(117.063 39.996)"
              fill="#eaeaea"
            />
            <text
              id="Hello_There_"
              data-name="Hello There!"
              transform="translate(117.063 32.339)"
              fill="#484949"
              fontSize="7"
              fontFamily="ArialMT, Arial"
            >
              <tspan x="0" y="0">
                Hello There!
              </tspan>
            </text>
            <rect
              id="Rectangle_1349"
              data-name="Rectangle 1349"
              width="78.516"
              height="6.198"
              transform="translate(117.063 50.727)"
              fill="#eaeaea"
            />
            <g id="Group_3190" data-name="Group 3190" transform="translate(49.752 48.776)">
              <circle
                id="Ellipse_163"
                data-name="Ellipse 163"
                cx="3.53"
                cy="3.53"
                r="3.53"
                fill="red"
              />
              <path
                id="Path_1241"
                data-name="Path 1241"
                d="M7.887,5.931,5.472,7.324A.246.246,0,0,1,5.1,7.111V4.324a.246.246,0,0,1,.372-.214L7.887,5.5A.245.245,0,0,1,7.887,5.931Z"
                transform="translate(-2.731 -2.183)"
                fill="#fff"
              />
              <path
                id="Path_1242"
                data-name="Path 1242"
                d="M14.873,2.36a4.185,4.185,0,0,1-.413,5.36l41.232,0V2.365Z"
                transform="translate(-7.744 -1.264)"
                fill="#2c2e2f"
                opacity="0.8"
              />
              <path
                id="Path_1243"
                data-name="Path 1243"
                d="M93.433,7.865a.108.108,0,0,1-.042.088.1.1,0,0,1-.121,0c-.028-.023-.056-.046-.079-.07l-.608-.525a.05.05,0,0,0-.028-.009h-.6a.1.1,0,0,1-.093-.046.093.093,0,0,1-.019-.06v-.78a.079.079,0,0,1,0-.033.109.109,0,0,1,.1-.079h.627a.035.035,0,0,0,.019,0l.618-.534a.807.807,0,0,1,.065-.056.1.1,0,0,1,.107-.009.1.1,0,0,1,.06.088v.014C93.433,6.183,93.433,7.526,93.433,7.865Z"
                transform="translate(-49.182 -3.071)"
                fill="#fff"
              />
              <path
                id="Path_1244"
                data-name="Path 1244"
                d="M97.042,7.422c.023.028.046.051.07.079.1.116.2.232.3.348a.136.136,0,0,1,.033.056.106.106,0,0,1-.051.116A.1.1,0,0,1,97.269,8c-.028-.028-.051-.06-.079-.093-.093-.107-.181-.214-.274-.32l0,0-.009.009c-.116.135-.228.269-.344.4a.1.1,0,0,1-.177-.033.1.1,0,0,1,.019-.1c.046-.056.093-.107.139-.163.074-.088.153-.177.228-.269a0,0,0,0,1,0,0,.717.717,0,0,1-.056-.06c-.107-.121-.209-.246-.316-.367a.153.153,0,0,1-.033-.06.1.1,0,0,1,.181-.084c.065.074.13.153.2.228.051.056.1.116.149.172l0,0,0,0c.111-.135.228-.265.339-.4a.1.1,0,0,1,.074-.042.1.1,0,0,1,.111.084.116.116,0,0,1-.023.088c-.121.144-.242.283-.367.427C97.047,7.417,97.042,7.422,97.042,7.422Z"
                transform="translate(-51.606 -3.645)"
                fill="#fff"
              />
              <path
                id="Path_1245"
                data-name="Path 1245"
                d="M24.1,5.97h.478a.857.857,0,0,1,.181.019.514.514,0,0,1,.172.07.451.451,0,0,1,.13.135.474.474,0,0,1,.009.409.394.394,0,0,1-.111.135.459.459,0,0,1-.158.079.621.621,0,0,1-.186.028h-.358v.785H24.1Zm.153.729H24.6a.619.619,0,0,0,.13-.014.306.306,0,0,0,.111-.051.241.241,0,0,0,.079-.088.308.308,0,0,0,.033-.139.252.252,0,0,0-.033-.135.268.268,0,0,0-.084-.093.3.3,0,0,0-.116-.051.627.627,0,0,0-.13-.019h-.339Z"
                transform="translate(-12.906 -3.197)"
                fill="#fff"
              />
              <path
                id="Path_1246"
                data-name="Path 1246"
                d="M26.95,5.73h.139V7.5H26.95Z"
                transform="translate(-14.432 -3.069)"
                fill="#fff"
              />
              <path
                id="Path_1247"
                data-name="Path 1247"
                d="M28.887,7.8v.144a.933.933,0,0,0,0,.116c0,.037,0,.07,0,.1s0,.06.009.093h-.13a1.008,1.008,0,0,1-.014-.177h0a.429.429,0,0,1-.149.153.471.471,0,0,1-.228.051.458.458,0,0,1-.26-.074.351.351,0,0,1-.088-.1A.3.3,0,0,1,28,7.963a.282.282,0,0,1,.065-.2.4.4,0,0,1,.153-.107.666.666,0,0,1,.2-.046,1.31,1.31,0,0,1,.181-.009h.163V7.54a.218.218,0,0,0-.088-.2.357.357,0,0,0-.218-.06.507.507,0,0,0-.33.121l-.074-.1a.46.46,0,0,1,.19-.111.617.617,0,0,1,.218-.037.487.487,0,0,1,.311.093.354.354,0,0,1,.116.3Zm-.279-.088a1.03,1.03,0,0,0-.172.014.626.626,0,0,0-.149.042.26.26,0,0,0-.107.074.151.151,0,0,0-.042.111.192.192,0,0,0,.023.088.189.189,0,0,0,.056.065.246.246,0,0,0,.079.037.27.27,0,0,0,.088.014.444.444,0,0,0,.186-.033.373.373,0,0,0,.116-.084.369.369,0,0,0,.06-.121.671.671,0,0,0,.019-.135V7.712Z"
                transform="translate(-14.994 -3.829)"
                fill="#fff"
              />
              <path
                id="Path_1248"
                data-name="Path 1248"
                d="M30.845,8.627a.44.44,0,0,1-.111.167.264.264,0,0,1-.186.06.352.352,0,0,1-.07,0l-.07-.014.014-.13c.019,0,.042.014.06.019a.314.314,0,0,0,.065.009.107.107,0,0,0,.065-.019.145.145,0,0,0,.051-.042.387.387,0,0,0,.037-.056c.009-.023.019-.042.028-.065l.1-.251L30.39,7.22h.158l.358.906.348-.906H31.4Z"
                transform="translate(-16.274 -3.866)"
                fill="#fff"
              />
              <path
                id="Path_1249"
                data-name="Path 1249"
                d="M38.249,7.474a.453.453,0,0,0,0-.074c0-.028,0-.056,0-.088a.506.506,0,0,0,0-.084c0-.028,0-.046,0-.06h.139c0,.042,0,.079,0,.116s0,.06,0,.074h.009a.365.365,0,0,1,.139-.153.409.409,0,0,1,.228-.065.366.366,0,0,1,.2.056.323.323,0,0,1,.13.177.339.339,0,0,1,.153-.177.445.445,0,0,1,.214-.056.431.431,0,0,1,.2.042.345.345,0,0,1,.19.251.7.7,0,0,1,.019.172v.641h-.139V7.609a.546.546,0,0,0-.014-.125.46.46,0,0,0-.042-.111.2.2,0,0,0-.084-.079.29.29,0,0,0-.135-.028.336.336,0,0,0-.163.037.268.268,0,0,0-.1.093.394.394,0,0,0-.051.121.577.577,0,0,0-.014.125V8.25h-.139V7.6a.465.465,0,0,0-.056-.242.185.185,0,0,0-.167-.093.362.362,0,0,0-.144.028.353.353,0,0,0-.121.084.405.405,0,0,0-.079.139.617.617,0,0,0-.028.2V8.25h-.139Z"
                transform="translate(-20.473 -3.824)"
                fill="#fff"
              />
              <path
                id="Path_1250"
                data-name="Path 1250"
                d="M42.52,6.167a.092.092,0,0,1,.033-.074.11.11,0,0,1,.074-.033.092.092,0,0,1,.074.033.11.11,0,0,1,.033.074.092.092,0,0,1-.033.074.11.11,0,0,1-.074.033.111.111,0,0,1-.107-.107Zm.037.427H42.7V7.672h-.139Z"
                transform="translate(-22.77 -3.245)"
                fill="#fff"
              />
              <path
                id="Path_1251"
                data-name="Path 1251"
                d="M43.729,7.474a.452.452,0,0,0,0-.074c0-.028,0-.056,0-.088a.5.5,0,0,0,0-.084c0-.028,0-.046,0-.06h.139c0,.042,0,.079,0,.116s0,.06,0,.074h.009a.365.365,0,0,1,.139-.153.409.409,0,0,1,.228-.065.432.432,0,0,1,.2.042.345.345,0,0,1,.19.251.7.7,0,0,1,.019.172v.641h-.139V7.609a.546.546,0,0,0-.014-.125.4.4,0,0,0-.042-.111.2.2,0,0,0-.084-.079.29.29,0,0,0-.135-.028.362.362,0,0,0-.144.028.354.354,0,0,0-.121.084.4.4,0,0,0-.079.139.618.618,0,0,0-.028.2V8.25h-.139Z"
                transform="translate(-23.407 -3.824)"
                fill="#fff"
              />
              <path
                id="Path_1252"
                data-name="Path 1252"
                d="M47.455,7.986a.452.452,0,0,0,0,.074c0,.028,0,.056,0,.088a.506.506,0,0,0,0,.084c0,.028,0,.046,0,.06h-.139c0-.042,0-.079,0-.116s0-.06,0-.074h-.009a.365.365,0,0,1-.139.153.409.409,0,0,1-.228.065.432.432,0,0,1-.2-.042.311.311,0,0,1-.125-.1.326.326,0,0,1-.06-.149,1.025,1.025,0,0,1-.019-.172V7.215h.139v.636a.546.546,0,0,0,.014.125.4.4,0,0,0,.042.111.2.2,0,0,0,.084.079.29.29,0,0,0,.135.028.362.362,0,0,0,.144-.028.354.354,0,0,0,.121-.084.405.405,0,0,0,.079-.139.618.618,0,0,0,.028-.2V7.21h.139Z"
                transform="translate(-24.923 -3.861)"
                fill="#fff"
              />
              <path
                id="Path_1253"
                data-name="Path 1253"
                d="M49.7,6.982h-.307v.7a.144.144,0,0,0,.153.153.458.458,0,0,0,.079-.009A.534.534,0,0,0,49.7,7.8l.014.125c-.028.009-.056.019-.093.028a.347.347,0,0,1-.093.014.361.361,0,0,1-.13-.023.215.215,0,0,1-.135-.149.4.4,0,0,1-.014-.107v-.7H49.02V6.861h.232V6.55h.139v.311H49.7Z"
                transform="translate(-26.251 -3.508)"
                fill="#fff"
              />
              <path
                id="Path_1254"
                data-name="Path 1254"
                d="M51.9,8.051a.481.481,0,0,1-.2.177.614.614,0,0,1-.265.056.561.561,0,0,1-.223-.042.489.489,0,0,1-.172-.116.6.6,0,0,1-.111-.181.61.61,0,0,1-.037-.232.6.6,0,0,1,.042-.223.521.521,0,0,1,.111-.177.573.573,0,0,1,.172-.121.554.554,0,0,1,.218-.042.538.538,0,0,1,.218.042.4.4,0,0,1,.158.116.523.523,0,0,1,.1.163.505.505,0,0,1,.033.186v.1h-.906a.37.37,0,0,0,.019.111A.329.329,0,0,0,51.118,8a.49.49,0,0,0,.125.111.374.374,0,0,0,.2.046.494.494,0,0,0,.209-.051.371.371,0,0,0,.153-.139Zm-.107-.427a.333.333,0,0,0-.028-.135.375.375,0,0,0-.079-.111.353.353,0,0,0-.121-.074.379.379,0,0,0-.144-.028.351.351,0,0,0-.19.046.391.391,0,0,0-.121.107.6.6,0,0,0-.065.116.253.253,0,0,0-.019.079Z"
                transform="translate(-27.252 -3.829)"
                fill="#fff"
              />
              <path
                id="Path_1255"
                data-name="Path 1255"
                d="M54.79,7.21h.158l.358.929.348-.924H55.8l-.423,1.078h-.144Z"
                transform="translate(-29.341 -3.861)"
                fill="#fff"
              />
              <path
                id="Path_1256"
                data-name="Path 1256"
                d="M57.42,6.167a.092.092,0,0,1,.033-.074.11.11,0,0,1,.074-.033.092.092,0,0,1,.074.033.11.11,0,0,1,.033.074.092.092,0,0,1-.033.074.11.11,0,0,1-.074.033.111.111,0,0,1-.107-.107Zm.033.427h.139V7.672h-.139Z"
                transform="translate(-30.749 -3.245)"
                fill="#fff"
              />
              <path
                id="Path_1257"
                data-name="Path 1257"
                d="M59.518,7.315h0a.422.422,0,0,1-.084.1.528.528,0,0,1-.107.07.365.365,0,0,1-.121.037.576.576,0,0,1-.125.014.6.6,0,0,1-.228-.042.5.5,0,0,1-.3-.3.641.641,0,0,1,0-.455.5.5,0,0,1,.3-.3.6.6,0,0,1,.228-.042.577.577,0,0,1,.125.014.523.523,0,0,1,.228.111.423.423,0,0,1,.084.1h0V5.75h.139V7.515h-.139Zm.014-.348a.44.44,0,0,0-.037-.172.378.378,0,0,0-.1-.139.427.427,0,0,0-.144-.093.406.406,0,0,0-.172-.037.428.428,0,0,0-.177.037.464.464,0,0,0-.135.093.429.429,0,0,0-.084.139.544.544,0,0,0,0,.344.35.35,0,0,0,.084.139.389.389,0,0,0,.135.093.428.428,0,0,0,.177.037.445.445,0,0,0,.176-.037.511.511,0,0,0,.144-.093.473.473,0,0,0,.1-.139A.537.537,0,0,0,59.532,6.967Z"
                transform="translate(-31.333 -3.079)"
                fill="#fff"
              />
              <path
                id="Path_1258"
                data-name="Path 1258"
                d="M62.608,8.061a.481.481,0,0,1-.2.177.614.614,0,0,1-.265.056.561.561,0,0,1-.223-.042.489.489,0,0,1-.172-.116.6.6,0,0,1-.111-.181.61.61,0,0,1-.037-.232.6.6,0,0,1,.042-.223.521.521,0,0,1,.111-.177.573.573,0,0,1,.172-.121.554.554,0,0,1,.218-.042.538.538,0,0,1,.218.042.4.4,0,0,1,.158.116.523.523,0,0,1,.1.163.505.505,0,0,1,.033.186v.1h-.906a.369.369,0,0,0,.019.111.329.329,0,0,0,.065.135.49.49,0,0,0,.125.111.374.374,0,0,0,.2.046.494.494,0,0,0,.209-.051.344.344,0,0,0,.153-.139ZM62.5,7.634a.333.333,0,0,0-.028-.135.375.375,0,0,0-.079-.111.353.353,0,0,0-.121-.074.379.379,0,0,0-.144-.028.351.351,0,0,0-.19.046.391.391,0,0,0-.121.107.323.323,0,0,0-.065.116.253.253,0,0,0-.019.079Z"
                transform="translate(-32.988 -3.834)"
                fill="#fff"
              />
              <path
                id="Path_1259"
                data-name="Path 1259"
                d="M64.38,7.717a.6.6,0,0,1,.042-.228.5.5,0,0,1,.3-.3.64.64,0,0,1,.455,0,.5.5,0,0,1,.3.3.6.6,0,0,1-.116.636.527.527,0,0,1-.181.116.64.64,0,0,1-.455,0,.5.5,0,0,1-.3-.3A.6.6,0,0,1,64.38,7.717Zm.139,0a.533.533,0,0,0,.028.172.35.35,0,0,0,.084.139.389.389,0,0,0,.135.093.438.438,0,0,0,.353,0,.464.464,0,0,0,.135-.093.429.429,0,0,0,.084-.139.544.544,0,0,0,0-.344.35.35,0,0,0-.084-.139.389.389,0,0,0-.135-.093.438.438,0,0,0-.353,0,.464.464,0,0,0-.135.093.429.429,0,0,0-.084.139A.533.533,0,0,0,64.519,7.717Z"
                transform="translate(-34.476 -3.829)"
                fill="#fff"
              />
              <path
                id="Path_1260"
                data-name="Path 1260"
                d="M34.51,6.629h.084a.631.631,0,0,0,.135-.014.274.274,0,0,0,.111-.051.263.263,0,0,0,.107-.232.273.273,0,0,0-.079-.2.322.322,0,0,0-.223-.074.329.329,0,0,0-.181.046.4.4,0,0,0-.13.135L34.19,6.16a.5.5,0,0,1,.186-.2A.532.532,0,0,1,34.64,5.9a.569.569,0,0,1,.181.028.425.425,0,0,1,.149.084.4.4,0,0,1,.139.316.355.355,0,0,1-.023.125.3.3,0,0,1-.06.107.377.377,0,0,1-.088.084.468.468,0,0,1-.107.056l.009,0a.375.375,0,0,1,.125.051.37.37,0,0,1,.1.093.4.4,0,0,1,.065.125.492.492,0,0,1,.023.144.466.466,0,0,1-.042.2A.447.447,0,0,1,35,7.465a.487.487,0,0,1-.167.093.719.719,0,0,1-.2.033.607.607,0,0,1-.311-.079.48.48,0,0,1-.2-.251L34.3,7.21a.348.348,0,0,0,.121.172.443.443,0,0,0,.358.033.276.276,0,0,0,.107-.065.341.341,0,0,0,.074-.1.206.206,0,0,0,.037-.135.312.312,0,0,0-.033-.153.329.329,0,0,0-.223-.158.863.863,0,0,0-.153-.019h-.07V6.629Z"
                transform="translate(-18.272 -3.16)"
                fill="#fff"
              />
              <path
                id="Path_1261"
                data-name="Path 1261"
                d="M7.887,5.931,5.472,7.324A.246.246,0,0,1,5.1,7.111V4.324a.246.246,0,0,1,.372-.214L7.887,5.5A.245.245,0,0,1,7.887,5.931Z"
                transform="translate(-2.731 -2.183)"
                fill="#fff"
              />
              <path
                id="Path_1263"
                data-name="Path 1263"
                d="M93.433,7.865a.108.108,0,0,1-.042.088.1.1,0,0,1-.121,0c-.028-.023-.056-.046-.079-.07l-.608-.525a.05.05,0,0,0-.028-.009h-.6a.1.1,0,0,1-.093-.046.093.093,0,0,1-.019-.06v-.78a.079.079,0,0,1,0-.033.109.109,0,0,1,.1-.079h.627a.035.035,0,0,0,.019,0l.618-.534a.807.807,0,0,1,.065-.056.1.1,0,0,1,.107-.009.1.1,0,0,1,.06.088v.014C93.433,6.183,93.433,7.526,93.433,7.865Z"
                transform="translate(-49.182 -3.071)"
                fill="#fff"
              />
              <path
                id="Path_1264"
                data-name="Path 1264"
                d="M97.042,7.422c.023.028.046.051.07.079.1.116.2.232.3.348a.136.136,0,0,1,.033.056.106.106,0,0,1-.051.116A.1.1,0,0,1,97.269,8c-.028-.028-.051-.06-.079-.093-.093-.107-.181-.214-.274-.32l0,0-.009.009c-.116.135-.228.269-.344.4a.1.1,0,0,1-.177-.033.1.1,0,0,1,.019-.1c.046-.056.093-.107.139-.163.074-.088.153-.177.228-.269a0,0,0,0,1,0,0,.717.717,0,0,1-.056-.06c-.107-.121-.209-.246-.316-.367a.153.153,0,0,1-.033-.06.1.1,0,0,1,.181-.084c.065.074.13.153.2.228.051.056.1.116.149.172l0,0,0,0c.111-.135.228-.265.339-.4a.1.1,0,0,1,.074-.042.1.1,0,0,1,.111.084.116.116,0,0,1-.023.088c-.121.144-.242.283-.367.427C97.047,7.417,97.042,7.422,97.042,7.422Z"
                transform="translate(-51.606 -3.645)"
                fill="#fff"
              />
              <path
                id="Path_1265"
                data-name="Path 1265"
                d="M24.1,5.97h.478a.857.857,0,0,1,.181.019.514.514,0,0,1,.172.07.451.451,0,0,1,.13.135.474.474,0,0,1,.009.409.394.394,0,0,1-.111.135.459.459,0,0,1-.158.079.621.621,0,0,1-.186.028h-.358v.785H24.1Zm.153.729H24.6a.619.619,0,0,0,.13-.014.306.306,0,0,0,.111-.051.241.241,0,0,0,.079-.088.308.308,0,0,0,.033-.139.252.252,0,0,0-.033-.135.268.268,0,0,0-.084-.093.3.3,0,0,0-.116-.051.627.627,0,0,0-.13-.019h-.339Z"
                transform="translate(-12.906 -3.197)"
                fill="#fff"
              />
              <path
                id="Path_1266"
                data-name="Path 1266"
                d="M26.95,5.73h.139V7.5H26.95Z"
                transform="translate(-14.432 -3.069)"
                fill="#fff"
              />
              <path
                id="Path_1267"
                data-name="Path 1267"
                d="M28.887,7.8v.144a.933.933,0,0,0,0,.116c0,.037,0,.07,0,.1s0,.06.009.093h-.13a1.008,1.008,0,0,1-.014-.177h0a.429.429,0,0,1-.149.153.471.471,0,0,1-.228.051.458.458,0,0,1-.26-.074.351.351,0,0,1-.088-.1A.3.3,0,0,1,28,7.963a.282.282,0,0,1,.065-.2.4.4,0,0,1,.153-.107.666.666,0,0,1,.2-.046,1.31,1.31,0,0,1,.181-.009h.163V7.54a.218.218,0,0,0-.088-.2.357.357,0,0,0-.218-.06.507.507,0,0,0-.33.121l-.074-.1a.46.46,0,0,1,.19-.111.617.617,0,0,1,.218-.037.487.487,0,0,1,.311.093.354.354,0,0,1,.116.3Zm-.279-.088a1.03,1.03,0,0,0-.172.014.626.626,0,0,0-.149.042.26.26,0,0,0-.107.074.151.151,0,0,0-.042.111.192.192,0,0,0,.023.088.189.189,0,0,0,.056.065.246.246,0,0,0,.079.037.27.27,0,0,0,.088.014.444.444,0,0,0,.186-.033.373.373,0,0,0,.116-.084.369.369,0,0,0,.06-.121.671.671,0,0,0,.019-.135V7.712Z"
                transform="translate(-14.994 -3.829)"
                fill="#fff"
              />
              <path
                id="Path_1268"
                data-name="Path 1268"
                d="M30.845,8.627a.44.44,0,0,1-.111.167.264.264,0,0,1-.186.06.352.352,0,0,1-.07,0l-.07-.014.014-.13c.019,0,.042.014.06.019a.314.314,0,0,0,.065.009.107.107,0,0,0,.065-.019.145.145,0,0,0,.051-.042.387.387,0,0,0,.037-.056c.009-.023.019-.042.028-.065l.1-.251L30.39,7.22h.158l.358.906.348-.906H31.4Z"
                transform="translate(-16.274 -3.866)"
                fill="#fff"
              />
              <path
                id="Path_1269"
                data-name="Path 1269"
                d="M38.249,7.474a.453.453,0,0,0,0-.074c0-.028,0-.056,0-.088a.506.506,0,0,0,0-.084c0-.028,0-.046,0-.06h.139c0,.042,0,.079,0,.116s0,.06,0,.074h.009a.365.365,0,0,1,.139-.153.409.409,0,0,1,.228-.065.366.366,0,0,1,.2.056.323.323,0,0,1,.13.177.339.339,0,0,1,.153-.177.445.445,0,0,1,.214-.056.431.431,0,0,1,.2.042.345.345,0,0,1,.19.251.7.7,0,0,1,.019.172v.641h-.139V7.609a.546.546,0,0,0-.014-.125.46.46,0,0,0-.042-.111.2.2,0,0,0-.084-.079.29.29,0,0,0-.135-.028.336.336,0,0,0-.163.037.268.268,0,0,0-.1.093.394.394,0,0,0-.051.121.577.577,0,0,0-.014.125V8.25h-.139V7.6a.465.465,0,0,0-.056-.242.185.185,0,0,0-.167-.093.362.362,0,0,0-.144.028.353.353,0,0,0-.121.084.405.405,0,0,0-.079.139.617.617,0,0,0-.028.2V8.25h-.139Z"
                transform="translate(-20.473 -3.824)"
                fill="#fff"
              />
              <path
                id="Path_1270"
                data-name="Path 1270"
                d="M42.52,6.167a.092.092,0,0,1,.033-.074.11.11,0,0,1,.074-.033.092.092,0,0,1,.074.033.11.11,0,0,1,.033.074.092.092,0,0,1-.033.074.11.11,0,0,1-.074.033.111.111,0,0,1-.107-.107Zm.037.427H42.7V7.672h-.139Z"
                transform="translate(-22.77 -3.245)"
                fill="#fff"
              />
              <path
                id="Path_1271"
                data-name="Path 1271"
                d="M43.729,7.474a.452.452,0,0,0,0-.074c0-.028,0-.056,0-.088a.5.5,0,0,0,0-.084c0-.028,0-.046,0-.06h.139c0,.042,0,.079,0,.116s0,.06,0,.074h.009a.365.365,0,0,1,.139-.153.409.409,0,0,1,.228-.065.432.432,0,0,1,.2.042.345.345,0,0,1,.19.251.7.7,0,0,1,.019.172v.641h-.139V7.609a.546.546,0,0,0-.014-.125.4.4,0,0,0-.042-.111.2.2,0,0,0-.084-.079.29.29,0,0,0-.135-.028.362.362,0,0,0-.144.028.354.354,0,0,0-.121.084.4.4,0,0,0-.079.139.618.618,0,0,0-.028.2V8.25h-.139Z"
                transform="translate(-23.407 -3.824)"
                fill="#fff"
              />
              <path
                id="Path_1272"
                data-name="Path 1272"
                d="M47.455,7.986a.452.452,0,0,0,0,.074c0,.028,0,.056,0,.088a.506.506,0,0,0,0,.084c0,.028,0,.046,0,.06h-.139c0-.042,0-.079,0-.116s0-.06,0-.074h-.009a.365.365,0,0,1-.139.153.409.409,0,0,1-.228.065.432.432,0,0,1-.2-.042.311.311,0,0,1-.125-.1.326.326,0,0,1-.06-.149,1.025,1.025,0,0,1-.019-.172V7.215h.139v.636a.546.546,0,0,0,.014.125.4.4,0,0,0,.042.111.2.2,0,0,0,.084.079.29.29,0,0,0,.135.028.362.362,0,0,0,.144-.028.354.354,0,0,0,.121-.084.405.405,0,0,0,.079-.139.618.618,0,0,0,.028-.2V7.21h.139Z"
                transform="translate(-24.923 -3.861)"
                fill="#fff"
              />
              <path
                id="Path_1273"
                data-name="Path 1273"
                d="M49.7,6.982h-.307v.7a.144.144,0,0,0,.153.153.458.458,0,0,0,.079-.009A.534.534,0,0,0,49.7,7.8l.014.125c-.028.009-.056.019-.093.028a.347.347,0,0,1-.093.014.361.361,0,0,1-.13-.023.215.215,0,0,1-.135-.149.4.4,0,0,1-.014-.107v-.7H49.02V6.861h.232V6.55h.139v.311H49.7Z"
                transform="translate(-26.251 -3.508)"
                fill="#fff"
              />
              <path
                id="Path_1274"
                data-name="Path 1274"
                d="M51.9,8.051a.481.481,0,0,1-.2.177.614.614,0,0,1-.265.056.561.561,0,0,1-.223-.042.489.489,0,0,1-.172-.116.6.6,0,0,1-.111-.181.61.61,0,0,1-.037-.232.6.6,0,0,1,.042-.223.521.521,0,0,1,.111-.177.573.573,0,0,1,.172-.121.554.554,0,0,1,.218-.042.538.538,0,0,1,.218.042.4.4,0,0,1,.158.116.523.523,0,0,1,.1.163.505.505,0,0,1,.033.186v.1h-.906a.37.37,0,0,0,.019.111A.329.329,0,0,0,51.118,8a.49.49,0,0,0,.125.111.374.374,0,0,0,.2.046.494.494,0,0,0,.209-.051.371.371,0,0,0,.153-.139Zm-.107-.427a.333.333,0,0,0-.028-.135.375.375,0,0,0-.079-.111.353.353,0,0,0-.121-.074.379.379,0,0,0-.144-.028.351.351,0,0,0-.19.046.391.391,0,0,0-.121.107.6.6,0,0,0-.065.116.253.253,0,0,0-.019.079Z"
                transform="translate(-27.252 -3.829)"
                fill="#fff"
              />
              <path
                id="Path_1275"
                data-name="Path 1275"
                d="M54.79,7.21h.158l.358.929.348-.924H55.8l-.423,1.078h-.144Z"
                transform="translate(-29.341 -3.861)"
                fill="#fff"
              />
              <path
                id="Path_1276"
                data-name="Path 1276"
                d="M57.42,6.167a.092.092,0,0,1,.033-.074.11.11,0,0,1,.074-.033.092.092,0,0,1,.074.033.11.11,0,0,1,.033.074.092.092,0,0,1-.033.074.11.11,0,0,1-.074.033.111.111,0,0,1-.107-.107Zm.033.427h.139V7.672h-.139Z"
                transform="translate(-30.749 -3.245)"
                fill="#fff"
              />
              <path
                id="Path_1277"
                data-name="Path 1277"
                d="M59.518,7.315h0a.422.422,0,0,1-.084.1.528.528,0,0,1-.107.07.365.365,0,0,1-.121.037.576.576,0,0,1-.125.014.6.6,0,0,1-.228-.042.5.5,0,0,1-.3-.3.641.641,0,0,1,0-.455.5.5,0,0,1,.3-.3.6.6,0,0,1,.228-.042.577.577,0,0,1,.125.014.523.523,0,0,1,.228.111.423.423,0,0,1,.084.1h0V5.75h.139V7.515h-.139Zm.014-.348a.44.44,0,0,0-.037-.172.378.378,0,0,0-.1-.139.427.427,0,0,0-.144-.093.406.406,0,0,0-.172-.037.428.428,0,0,0-.177.037.464.464,0,0,0-.135.093.429.429,0,0,0-.084.139.544.544,0,0,0,0,.344.35.35,0,0,0,.084.139.389.389,0,0,0,.135.093.428.428,0,0,0,.177.037.445.445,0,0,0,.176-.037.511.511,0,0,0,.144-.093.473.473,0,0,0,.1-.139A.537.537,0,0,0,59.532,6.967Z"
                transform="translate(-31.333 -3.079)"
                fill="#fff"
              />
              <path
                id="Path_1278"
                data-name="Path 1278"
                d="M62.608,8.061a.481.481,0,0,1-.2.177.614.614,0,0,1-.265.056.561.561,0,0,1-.223-.042.489.489,0,0,1-.172-.116.6.6,0,0,1-.111-.181.61.61,0,0,1-.037-.232.6.6,0,0,1,.042-.223.521.521,0,0,1,.111-.177.573.573,0,0,1,.172-.121.554.554,0,0,1,.218-.042.538.538,0,0,1,.218.042.4.4,0,0,1,.158.116.523.523,0,0,1,.1.163.505.505,0,0,1,.033.186v.1h-.906a.369.369,0,0,0,.019.111.329.329,0,0,0,.065.135.49.49,0,0,0,.125.111.374.374,0,0,0,.2.046.494.494,0,0,0,.209-.051.344.344,0,0,0,.153-.139ZM62.5,7.634a.333.333,0,0,0-.028-.135.375.375,0,0,0-.079-.111.353.353,0,0,0-.121-.074.379.379,0,0,0-.144-.028.351.351,0,0,0-.19.046.391.391,0,0,0-.121.107.323.323,0,0,0-.065.116.253.253,0,0,0-.019.079Z"
                transform="translate(-32.988 -3.834)"
                fill="#fff"
              />
              <path
                id="Path_1279"
                data-name="Path 1279"
                d="M64.38,7.717a.6.6,0,0,1,.042-.228.5.5,0,0,1,.3-.3.64.64,0,0,1,.455,0,.5.5,0,0,1,.3.3.6.6,0,0,1-.116.636.527.527,0,0,1-.181.116.64.64,0,0,1-.455,0,.5.5,0,0,1-.3-.3A.6.6,0,0,1,64.38,7.717Zm.139,0a.533.533,0,0,0,.028.172.35.35,0,0,0,.084.139.389.389,0,0,0,.135.093.438.438,0,0,0,.353,0,.464.464,0,0,0,.135-.093.429.429,0,0,0,.084-.139.544.544,0,0,0,0-.344.35.35,0,0,0-.084-.139.389.389,0,0,0-.135-.093.438.438,0,0,0-.353,0,.464.464,0,0,0-.135.093.429.429,0,0,0-.084.139A.533.533,0,0,0,64.519,7.717Z"
                transform="translate(-34.476 -3.829)"
                fill="#fff"
              />
              <path
                id="Path_1280"
                data-name="Path 1280"
                d="M34.51,6.629h.084a.631.631,0,0,0,.135-.014.274.274,0,0,0,.111-.051.263.263,0,0,0,.107-.232.273.273,0,0,0-.079-.2.322.322,0,0,0-.223-.074.329.329,0,0,0-.181.046.4.4,0,0,0-.13.135L34.19,6.16a.5.5,0,0,1,.186-.2A.532.532,0,0,1,34.64,5.9a.569.569,0,0,1,.181.028.425.425,0,0,1,.149.084.4.4,0,0,1,.139.316.355.355,0,0,1-.023.125.3.3,0,0,1-.06.107.377.377,0,0,1-.088.084.468.468,0,0,1-.107.056l.009,0a.375.375,0,0,1,.125.051.37.37,0,0,1,.1.093.4.4,0,0,1,.065.125.492.492,0,0,1,.023.144.466.466,0,0,1-.042.2A.447.447,0,0,1,35,7.465a.487.487,0,0,1-.167.093.719.719,0,0,1-.2.033.607.607,0,0,1-.311-.079.48.48,0,0,1-.2-.251L34.3,7.21a.348.348,0,0,0,.121.172.443.443,0,0,0,.358.033.276.276,0,0,0,.107-.065.341.341,0,0,0,.074-.1.206.206,0,0,0,.037-.135.312.312,0,0,0-.033-.153.329.329,0,0,0-.223-.158.863.863,0,0,0-.153-.019h-.07V6.629Z"
                transform="translate(-18.272 -3.16)"
                fill="#fff"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

MockVideoItem.propTypes = {
  size: PropTypes.number,
  title: PropTypes.string,
};

MockVideoItem.defaultProps = {
  size: 16,
  title: 'Example Video',
};
